import React from 'react'

import { Box, H1 } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

export const AddQuantityTitle: React.FC = () => {
  const { t } = useLocalizations()
  const title = t('quantity-title')
  return (
    <Box mb="to-actions">
      <H1 fontSkin="title-headline">{title}</H1>
    </Box>
  )
}
